// Maintained by hand: register each new controller here, in the existing order.
// ./bin/rails stimulus:manifest:update writes a separate index.js instead; don't commit it.

import { application } from "./application"

import HouseFallbackController from "./house_fallback_controller"
application.register("house-fallback", HouseFallbackController)

import AdsenseController from "./adsense_controller"
application.register("adsense", AdsenseController)

import BackToTopController from "./back_to_top_controller"
application.register("back-to-top", BackToTopController)

import BromonPopupController from "./bromon_popup_controller"
application.register("bromon-popup", BromonPopupController)

import CategoriesFilterController from "./categories_filter_controller"
application.register("categories-filter", CategoriesFilterController)

import ClickBurstController from "./click_burst_controller"
application.register("click-burst", ClickBurstController)

import ConsentGateController from "./consent_gate_controller"
application.register("consent-gate", ConsentGateController)

import ContactFormController from "./contact_form_controller"
application.register("contact-form", ContactFormController)

import CursorPackController from "./cursor_pack_controller"
application.register("cursor-pack", CursorPackController)

import CursorGhostController from "./cursor_ghost_controller"
application.register("cursor-ghost", CursorGhostController)

import CursorPreviewController from "./cursor_preview_controller"
application.register("cursor-preview", CursorPreviewController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ExpandableController from "./expandable_controller"
application.register("expandable", ExpandableController)

import ExtensionController from "./extension_controller"
application.register("extension", ExtensionController)

import ExtensionStoreLinkController from "./extension_store_link_controller"
application.register("extension-store-link", ExtensionStoreLinkController)

import GuideTabsController from "./guide_tabs_controller"
application.register("guide-tabs", GuideTabsController)

import HeroEasterEggController from "./hero_easter_egg_controller"
application.register("hero-easter-egg", HeroEasterEggController)

import NavbarSearchController from "./navbar_search_controller"
application.register("navbar-search", NavbarSearchController)

import PopupController from "./popup_controller"
application.register("popup", PopupController)

import PromoPopupController from "./promo_popup_controller"
application.register("promo-popup", PromoPopupController)

import RailController from "./rail_controller"
application.register("rail", RailController)

import RotatorController from "./rotator_controller"
application.register("rotator", RotatorController)

import ScrollSpyController from "./scroll_spy_controller"
application.register("scroll-spy", ScrollSpyController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import TagsBrowseController from "./tags_browse_controller"
application.register("tags-browse", TagsBrowseController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ThemeSwitcherController from "./theme_switcher_controller"
application.register("theme-switcher", ThemeSwitcherController)

import WallpapersPopupController from "./wallpapers_popup_controller"
application.register("wallpapers-popup", WallpapersPopupController)
